<div class="main_content_wrapper">
  <div class="main_content">

    <div *ngIf="focusIndex == 0">
      <div class="VideoWindow" [ngClass]="{'FullScreen':FullScreen}">
        <video width="100%" autoplay muted id="myvideo" preload="none" #movie>
          <source src="http://iids-ch1.multicdnet.com/live_1/playlist.m3u8" />
        </video>
      </div>
    </div>

    <div *ngIf="focusIndex == 1">
      <div class="VideoWindow" [ngClass]="{'FullScreen':FullScreen}">
        <video width="100%" autoplay muted id="myvideo" preload="none" #movie>
          <source src="http://iids-ch4.multicdnet.com/live_1/playlist.m3u8" />
        </video>
      </div>
    </div>

    <div *ngIf="focusIndex == 2">
      <div class="VideoWindow" [ngClass]="{'FullScreen':FullScreen}">
        <video width="100%" autoplay muted id="myvideo" preload="none" #movie>
          <source src="http://iids-ch8.multicdnet.com/live_1/playlist.m3u8" />
        </video>
      </div>
    </div>

    <div *ngIf="focusIndex == 3">
      <div class="VideoWindow" [ngClass]="{'FullScreen':FullScreen}">
        <video width="100%" autoplay muted id="myvideo" preload="none" #movie>
          <source src="http://iids-ch3.multicdnet.com/live_1/playlist.m3u8" />
        </video>
      </div>
    </div>

    <div *ngIf="focusIndex == 4">
      <div class="VideoWindow" [ngClass]="{'FullScreen':FullScreen}">
        <video width="100%" autoplay muted id="myvideo" preload="none"#movie>
          <source src="http://iids-ch6.multicdnet.com/live_1/playlist.m3u8" />
        </video>
      </div>

    </div>
    <div class="remark">
      <ng-container *ngIf="lang !='eng'">
        「決定」ボタンでフルスクリーンの切り替えができます。
      </ng-container>
      <ng-container *ngIf="lang ==='eng'">
        The center button toggles between full screen.
      </ng-container>

    </div>


  </div>

</div>